export const PROJECT_CREATED_TO_UPLOADING_SEC = 0.5;
export const VIDEO_UPLOADING_SEC = 2;
// Константы от МЛ для минутного видео
// Константы переходов из одного статуса в другой рандомные
export const VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC = 2;
export const SEPARATE_BACKGROUND_SEC = 8;
export const SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC = 1;
export const SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC = 1;
export const TRANSCRIBING_SEGMENTS_SEC = 8;
export const TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC = 1;
export const DETERMINING_SPEAKERS_SEC = 8;
export const DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC = 1;
export const VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC = 0.5;
export const TRANSCRIPTION_SEC = 32;
export const TRANSCRIPTION_TO_VOICE_SUGGESTING_SEC = 0.5;
export const VOICE_SUGGESTING_SEC = 20;
export const VOICE_SUGGESTING_TO_TRANSLATION_SEC = 0.5;
export const VOICE_SUGGESTING_TO_VOICEOVER_GENERATING_SEC = 1;
export const TRANSLATION_SEC = 4;
export const TRANSLATION_TO_VOICEOVER_SEC = 1;
export const VOICEOVER_GENERATING_SEC = 19;
export const VOICEOVER_TO_MERGING_SEC = 1;
export const MERGING_GENERATING_SEC = 6;
